import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../services/api';

export default function PublicCancelOnlineBookingPage() {
  const { cancelToken } = useParams();

  const [loading, setLoading] = useState(true);
  const [appointment, setAppointment] = useState(null);
  const [codeSent, setCodeSent] = useState(false);
  const [code, setCode] = useState('');
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    loadData();
  }, [cancelToken]);

  const loadData = async () => {
    try {
      setLoading(true);

      const response = await api.get(
        `/online-booking/cancel/${cancelToken}`
      );

      setAppointment(response.data);
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível localizar este agendamento.'
      );
    } finally {
      setLoading(false);
    }
  };

  const sendCode = async () => {
    try {
      setError('');

      await api.post(
        '/online-booking/cancel/start',
        {
          cancel_token: cancelToken,
        }
      );

      setCodeSent(true);

      window.alert(
        'Código enviado para o e-mail vinculado ao agendamento.'
      );
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível enviar o código.'
      );
    }
  };

  const confirmCancel = async () => {
    try {
      setError('');

      await api.post(
        '/online-booking/cancel/confirm',
        {
          cancel_token: cancelToken,
          code,
        }
      );

      setSuccess(true);

      window.alert(
        'Agendamento cancelado com sucesso.'
      );
    } catch (err) {
      setError(
        err?.response?.data?.detail ||
        'Não foi possível cancelar.'
      );
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        Carregando...
      </div>
    );
  }

  if (success) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow p-6 max-w-md w-full">
          <h1 className="text-xl font-bold mb-4">
            Cancelamento realizado
          </h1>

          <p>
            Seu agendamento foi cancelado com sucesso.
          </p>
        </div>
      </div>
    );
  }

  if (!appointment) {
    return (
      <div className="min-h-screen flex items-center justify-center p-4">
        <div className="text-red-600">
          {error}
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex justify-center p-4">
      <div className="bg-white rounded-xl shadow p-6 max-w-md w-full space-y-4">

        <h1 className="text-xl font-bold">
          Cancelar agendamento
        </h1>

        <div className="bg-gray-50 rounded-lg p-4 text-sm space-y-2">
          <p>
            <strong>Paciente:</strong> {appointment.patient_name}
          </p>

          <p>
            <strong>Profissional:</strong> {appointment.professional_name}
          </p>

          <p>
            <strong>Data:</strong> {appointment.appointment_date}
          </p>

          <p>
            <strong>Horário:</strong> {appointment.start_time} às {appointment.end_time}
          </p>
        </div>

        {!codeSent ? (
          <button
            onClick={sendCode}
            className="w-full bg-red-600 text-white py-3 rounded-lg"
          >
            Enviar código de confirmação
          </button>
        ) : (
          <>
            <input
              type="text"
              value={code}
              onChange={(e) => setCode(e.target.value)}
              placeholder="Digite o código recebido"
              className="w-full border rounded-lg px-3 py-2"
            />

            <button
              onClick={confirmCancel}
              className="w-full bg-red-600 text-white py-3 rounded-lg"
            >
              Confirmar cancelamento
            </button>
          </>
        )}

        {error && (
          <p className="text-red-600 text-sm">
            {error}
          </p>
        )}
      </div>
    </div>
  );
}